import { AxiosRequestConfig } from 'axios';

import { fetcher } from '@hh.ru/front-static-app';

type DataRequest<D = Record<string, unknown>> = Omit<AxiosRequestConfig, 'params' | 'headers'> & {
    params: D;
    headers?: Record<string, unknown>;
};

interface RequestWithBodyParams {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    $bodyParams?: Record<string, any>;
}

interface Api {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    request: Record<string, any> & RequestWithBodyParams;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    response: Record<string, any> | void;
}

/**
 * Выборочно делает поля интерфейса необязательными
 */
type PartialOmit<T, K extends keyof T> = Omit<T, K> & {
    [P in K]?: T[P];
};

/**
 * Извлекает $bodyParams в корень
 */
type ExtractBodyParams<Source extends RequestWithBodyParams | never> = Omit<
    Source & Required<Source>['$bodyParams'],
    '$bodyParams'
>;

/**
 * Позволяет сделать некоторые поля из стандартного запроса необязательными, для случаев когда эти поля сетятся в питоне
 */
export interface PythonLayerInterceptor<A extends Api, Remove extends keyof ExtractBodyParams<A['request']> = never> {
    params: PartialOmit<ExtractBodyParams<A['request']>, Remove>;
    response: A['response'];
}

export default {
    ...fetcher,
    get: <U extends keyof FetcherGetApi>(
        url: U,
        data?: DataRequest<FetcherGetApi[U]['queryParams']>
    ): Promise<FetcherGetApi[U]['response']> =>
        // TODO: fix ts-check
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        fetcher.get<FetcherGetApi[U]['response']>(url, data).then(({ data }) => data),
};
